<template>
  <div class="container mx-auto my-10 p-4">
    <div class="w-full flex place-content-center">
      <div class="w-1/2 p-4 text-center">
        <div class="card-header p-4">
          <h2 v-if="language =='en'">Self Assessment</h2>
          <h2 v-else>自评</h2>
        </div>
        <div class="card-body p-4">
          <p
            v-if="language == 'en'"
          >Please complete the following information for us to work on your personalised solution. All information provided in your self-assessment is Totally Confidential. Data transferred are encrypted.</p>
          <p v-else>请完成下述信息以便我们为您提供私人订制的解决方案。所有在您的自评信息中心的信息都是完全保密的。数据传输是加密的。</p>
        </div>

        <p>{{ assessment ? assessment.id : ''}}</p>

        <div class="flex flex-wrap bg-white rounded-md p-4" v-if="step === 0 || step === 6">
          <Select
            class="w-1/2"
            :label="language == 'en' ? 'Age' : '年龄'"
            name="age"
            id="age"
            placeholder="Select one"
            v-model="assessment.age"
            :options="age"
          />
          <Select
            class="w-1/2"
            :label="language == 'en' ? 'Gender' : '性别'"
            name="gender"
            id="gender"
            placeholder="Select one"
            v-model="assessment.gender"
            :options="gender"
          />
        </div>
        <div class="flex flex-wrap bg-white rounded-md p-4" v-if="step === 1 || step === 6">
          <TextInput
            type="number"
            class="w-1/2"
            :label="language == 'en' ? 'Height (cm)' : '身高 (cm)'"
            name="height"
            id="height"
            v-model="assessment.height"
          />
          <TextInput
            type="number"
            class="w-1/2"
            :label="language =='en' ? 'Weight (kg)' : '体重 (kg)'"
            name="weight"
            id="weight"
            v-model="assessment.weight"
          />
        </div>

        <div class="flex flex-wrap bg-white rounded-md p-4" v-if="step === 2 || step === 6">
          <RadioSet
            class="w-full"
            :label="language == 'en' ? 'Are you a smoker?' : '是否吸烟'"
            name="smoker"
            id="smoker"
            v-model="assessment.smoker"
            :options="smoker"
          />
        </div>

        <div class="flex flex-wrap bg-white rounded-md p-4" v-if="step === 3 || step === 6">
          <TextInput
            type="textarea"
            class="w-full"
            :label="language == 'en' ? 'Other medications taken' : '其他正在使用的药物'"
            name="medications"
            id="medications"
            v-model="assessment.medications"
          />
        </div>

        <div class="flex flex-wrap bg-white rounded-md p-4" v-if="step === 4 || step === 6">
          <CheckboxSet
            class="w-full"
            :label="language == 'en' ? 'Which of the following Life Style Factors apply to you?' : '你具有下列哪些生活方式因素'"
            name="factors"
            id="factors"
            v-model="selectedFactors"
            :options="factor"
          />
        </div>

        <div class="flex-wrap bg-white rounded-md p-4" v-if="step === 5 || step === 6">
          <p
            v-if="language == 'en'"
            class="custom-label text-sm m-0 px-4"
          >Select presenting syndrome</p>
          <p v-else class="custom-label text-sm m-0 px-4">选择展示出的症状</p>
          <p
            v-if="language == 'en'"
            class="custom-label text-sm m-0 px-4"
          >There is a limit of two (2) syndromes</p>
          <p v-else class="custom-label text-sm m-0 px-4">最多2个</p>
          <div v-for="(group, key) in syndrome" :key="key">
            <CheckboxSet
              class="w-full"
              :label="language == 'en' ? group[0].taxon : group[0].taxon_zh"
              name="syndromes"
              id="syndromes"
              v-model="selectedSyndromeIDs"
              :options="group"
              :language="language"
              :limitReached="selectedSyndromeIDs.length >= 2"
            />
          </div>
        </div>

        <div class="flex flex-wrap bg-white rounded-md p-4" v-if="step === 6">
          <CheckboxSet
            class="w-full"
            :label="language == 'en' ? 'Are you interested in purchasing the provided recommendation?' : 'Are you interested in purchasing the provided recommendation?'"
            name="factors"
            id="factors"
            v-model="assessment.intent_to_buy"
            :options="[{'label': 'Yes', 'value': 1}]"
          />
          <TextInput
            class="w-full"
            :label="language == 'en' ? 'English Name' : 'English Name'"
            name="name"
            id="name"
            v-model="assessment.name"
          />

          <TextInput
            type="textarea"
            class="w-full"
            :label="language == 'en' ? 'Address' : 'Address'"
            name="address"
            id="address"
            v-model="assessment.address"
          />
        </div>

        <Button
          class="w-full"
          v-if="step !== 6"
          type="submit"
          id="register-submit"
          :label="language == 'en' ? 'Next' : '下一步'"
          v-on:click="handleUpdate"
          :disabled="!isMinSyndromeAmountSelected"
        />
        <Button
          class="w-full"
          v-if="step !== 6"
          type="submit"
          id="register-logout"
          :label="language == 'en' ? 'Logout' : '退出'"
          v-on:click="logout"
        />

        <Button
          class="w-full"
          v-if="step == 6"
          type="submit"
          id="goto-questions"
          :label="language == 'en' ? 'Continue' : '继续'"
          v-on:click="gotoQuestions"
          :disabled="!isMinSyndromeAmountSelected"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as _ from "lodash";
import TextInput from "./forms/TextInput";
import Select from "./forms/Select";
import RadioSet from "./forms/RadioSet";
import CheckboxSet from "./forms/CheckboxSet";
import Button from "./forms/Button";

export default {
  data() {
    return {
      _,
      assessment: null,
      step: 0,
      selectedFactors: [],
      selectedSyndromeIDs: []
    };
  },
  props: ["user", "options", "loadedassessment"],

  computed: {
    ...mapGetters({
      language: "clientLanguage"
    }),
    _user() {
      return JSON.parse(this.user);
    },
    _options() {
      return JSON.parse(this.options);
    },
    _assessment() {
      return this.$store.getters.assessment;
    },
    _loadedAssessment() {
      return JSON.parse(this.loadedassessment);
    },
    age() {
      return this._options.age.map(age => {
        return { value: age, label: age };
      });
    },
    gender() {
      if (this.language == "en") {
        return this._options.gender.options.map(gender => {
          return { value: gender, label: _.capitalize(gender) };
        });
      } else {
        return this._options.gender.options_zh.map(gender => {
          return { value: gender, label: _.capitalize(gender) };
        });
      }
    },
    smoker() {
      if (this.language == "en") {
        return this._options.smoker.map(smoker => {
          return { value: smoker, label: smoker ? "Yes" : "No" };
        });
      } else {
        return this._options.smoker.map(smoker => {
          return { value: smoker, label: smoker ? "是" : "否" };
        });
      }
    },
    factor() {
      return this._options.factor.map(factor => {
        return {
          value: factor.id,
          label: this.language == "en" ? factor.name : factor.name_zh
        };
      });
    },
    syndrome() {
      return this._options.syndrome;
    },
    syndromeObjectArray() {
      // This is just a helper variable for selectedSyndromeObjects
      let syndromeObjectArray = [];

      for (const [key, value] of Object.entries(this.syndrome)) {
        syndromeObjectArray.push(value);
      }

      return syndromeObjectArray.flat();
    },
    selectedSyndromeObjects() {
      // Need to have the full syndrome object in order to load questionnaire
      // NOTE this could probably be done in the questionnaire component
      let selecedSyndromeObjects = [];

      for (const syndromeID of this.selectedSyndromeIDs) {
        for (const syndromeObject of this.syndromeObjectArray) {
          if (syndromeObject.value == syndromeID) {
            selecedSyndromeObjects.push(syndromeObject);
          }
        }
      }

      return selecedSyndromeObjects;
    },
    isMinSyndromeAmountSelected() {
      if (this.step == 5 || this.step == 6) {
        if (this.selectedSyndromeIDs.length >= 1) {
          return true;
        }

        return false;
      }

      return true;
    }
  },

  components: {
    TextInput,
    Select,
    CheckboxSet,
    RadioSet,
    Button
  },

  beforeMount() {
    // Load in the assessment from localstorage
    this.assessment = Object.assign({}, this._assessment);

    this.selectedFactors = this.assessment.factors || [];
    this.selectedSyndromeIDs = this.assessment.syndromes || [];
  },
  mounted() {
    // This is where we check if the assessment in the database matches the one in the store
    // The DB assessment needs to take priority over localstorage
    if (this.assessment.id != this._loadedAssessment.id) {
      this.assessment = Object.assign({}, this._loadedAssessment);
      this.selectedFactors = this._loadedAssessment.factors || [];
      this.selectedSyndromeIDs = this._loadedAssessment.syndromes || [];
      this.$store.dispatch("updateAssessment", this.assessment);
    }
  },

  watch: {
    assessment: {
      handler: function(data) {
        if (!!data) {
          this.$store.dispatch("updateAssessment", data);
        }
      },
      deep: true,
      immediate: true
    },
    selectedFactors(val) {
      this.assessment.factors = val;
    },
    selectedSyndromeIDs(val) {
      this.assessment.syndromes = val;
    },
    selectedSyndromeObjects(val) {
      this.assessment.syndromeObjects = val;
    }
  },
  methods: {
    handleUpdate() {
      this.$store.dispatch("updateAssessment", this.assessment).then(() => {
        this.step = this.step + 1;
      });
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        window.location.href = "/";
      });
    },
    gotoQuestions() {
      this.$store.dispatch("updateAssessment", this.assessment).then(() => {
        window.location.href = "/questionnaires";
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-label {
  display: block;
  text-align: left;
  font-weight: 600;
  text-transform: uppercase;
  color: #1c4c56;
}

@media screen and (max-width: 767px) {
  .w-1\/2 {
    width: 100%;
  }
}
</style>
